<template>
  <div
    class="news-cont-box"
    ref="box">
    <div
      class="Introduction"
      @click="imgPath" ref="Introduction"
      v-html="fullWord"></div>
    <div
      v-if="wmkUse"
      style="text-align:center;margin-bottom:16px;padding:0 30px;padding-top:16px;border-top:1px solid #f3f3f3"
      :style="{fontSize:waterMark.wmkWordSize+'px',opacity:(waterMark.wmkWordTrans/100)}">
      {{waterMark.wmkWordContent}}
    </div>
  </div>
</template>

<script>
import * as sctipts from "../service/share";
export default {
  data () {
    return {
      pageType:2,
      title: "",
      author: "",
      source: "",
      createTime: "",
      fullWord: "",
      webcommentList: [],
      type: "0",
      appUrl: "",
      appName: "",
      appIcon: "",
      editor: "",
      linkList: [],
      newList: [],
      showFullContent: false,
      openUrl: "",
      viewTotal: "",
      timer: null,
      // 水印
      waterMark: {},
      // 是否开启水印 wmkUse 0 否 1 是
      wmkUse: 0
    };
  },
  mounted () {
    //箭头页面加载返回页面高度
    let observer = new MutationObserver((mutations, observer) => {
      this.initPage();
      let images = this.$refs.Introduction.querySelectorAll("img");
      const promises = Array.prototype.slice.call(images).map((node) => {
        return new Promise((resolve, reject) => {
          let loadImg = new Image();
          loadImg.src = node.src;
          loadImg.onload = () => {
            resolve(node);
          };
        });
      });
      // 利用Promise.all监听所有图片加载完成
      Promise.all([promises])
        .then((results) => {
          //执行方法
          this.initPage();
        })
        .catch((e) => {
          console.error("网络异常或其他程序异常", e);
        });
    });
    //创建实例
    observer.observe(this.$refs.Introduction, {
      childList: true, // 子节点的变动（新增、删除或者更改）
      attributes: true, // 属性的变动
      characterData: true, // 节点内容或节点文本的变动
      subtree: true, // 是否将观察器应用于该节点的所有后代节点
      attributeFilter: ["class", "style", "height"], // 观察特定属性
      attributeOldValue: true, // 观察 attributes 变动时，是否需要记录变动前的属性值
      characterDataOldValue: true, // 观察 characterData 变动，是否需要记录变动前的值
    });
    if (this.equipmentType() == "iOS") {
      this.type = 0;
    } else if (this.equipmentType() == "Android") {
      this.type = 1;
    } else {
      this.type = 3;
    }
    if (this.$route.query.id) {
      sctipts
        .getCont({
            id:this.$route.query.id,
            type:this.$route.query.type
    })
        .then(({
          data
        }) => {
          if (data.status == 0) {
            if (data.data) {
              this.title = data.data.title || "";
              this.source = data.data.source || "";
              this.author = data.data.author || "";
              this.editor = data.data.editor || "";
              this.createTime = sctipts.initTime(data.data.createTime, 1);
              this.fullWord = data.data.fullWord || "";
              this.viewTotal = data.data.viewTotal;
              document.title = this.title;
              this.linkList = data.data.linkList;
              this.newList = data.data.newList;
              this.wmkUse = data.data.wmsUse;
              if (this.wmkUse == 1) {
                // 获取文章水印列表
                  let obj = {
                    pageIndex: 1,
                    pageSize: 99999,
                    wmkRange: 1,
                  };
                  sctipts.getWater(obj).then((res) => {
                    if (res.data.status === 0 && res.data.data.list) {
                      var waterData = res.data.data.list.filter((val) => {
                        return val.wmkId == data.data.wmkId
                      })
                      this.waterMark = waterData[0]
                      console.log(this.waterMark);
                    };
                  })
              }
              //关闭遮罩
              if (this.equipmentType() == "Android") {
                try {
                  window.Android.didFinishLayer();
                } catch (error) { }
              } else if (this.equipmentType() == "iOS") {
                try {
                  window.webkit.messageHandlers.didFinishLayer.postMessage(
                    "didFinishLayer"
                  );
                } catch (error) { }
              }
              //多次延时返回页面高度
              this.timer = setInterval(() => {
                this.initPage();
              }, 500);
              setTimeout(() => {
                clearInterval(this.timer);
              }, 15000);
            }
          } else {
            console.log(data.desc);
          }
        })
        .catch((res) => {
          console.log("连接服务器错误");
        });
    } else {
      console.log("未获取id");
    }
    window.audioPause = this.audioPause
    window.videoPause = this.clearVideo
  },
  methods: {
    clearVideo () {
      this.$refs.Introduction.querySelectorAll("video").forEach((element) => {
        element.pause();
      });
    },
    clearAudio () { },
    equipmentType () {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return "Android";
      } else if (isiOS) {
        return "iOS";
      } else {
        return "noMobileDevices";
      }
    },
    initTime (time, type) {
      return sctipts.initTime(time, type);
    },
    getDateDiff (time) {
      return sctipts.getDateDiff(time);
    },
    imgPath (event) {
      if (event.target.nodeName == "IMG") {
        // 获取触发事件对象的属性
        let allPathArr = [];
        let index = "";
        for (
          let i = 0; i < this.$refs.Introduction.querySelectorAll("img").length; i++
        ) {
          allPathArr.push(
            this.$refs.Introduction.querySelectorAll("img")[i].src
          );
        }
        allPathArr.forEach((val, ind) => {
          if (val == event.target.src) {
            index = ind;
          }
        });

        let objData = {
          thisPath: event.target.src,
          allPath: allPathArr,
          indexOf: index,
        };
        if (this.equipmentType() == "iOS") {
          window.webkit.messageHandlers.showImage.postMessage(objData);
        } else if (this.equipmentType() == "Android") {
          Android.openImage(event.target.src, allPathArr, index);
        }
      }
    },
    audioPause () {
      this.$refs.Introduction.querySelectorAll("audio").forEach((element) => {
        element.pause();
      });
    },
    initPage () {
      //设置视频不能全屏播放
      let videoDomArr = this.$refs.Introduction.querySelectorAll("video");
      for (let i = 0; i < videoDomArr.length; i++) {
        videoDomArr[i].setAttribute("x5-video-player-type", "h5")
        videoDomArr[i].setAttribute("webkit-playsinline", "")
        videoDomArr[i].setAttribute("playsinline", "")
        videoDomArr[i].setAttribute("controlslist", "nodownload")
      }
      if (this.equipmentType() == "Android") {
        try {
          window.Android.resize(this.$refs.box.offsetHeight);
        } catch (error) { }
      }
    },
  },
  beforeDestroy () {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
.app-view {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 13px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  z-index: 99999;
}

.app-view > li:nth-child(1) {
  height: 25px;
}

.app-view > li:nth-child(1) > img {
  width: 25px;
  height: 25px;
  display: block;
  float: left;
}

.app-view > li:nth-child(1) > p {
  font-size: 13px;
  color: #333333;
  float: left;
  margin-left: 8px;
  line-height: 25px;
}

.app-view > li:nth-child(2) {
  height: 26px;
  overflow: hidden;
}

.app-view > li:nth-child(2) > a {
  display: block;
  width: 81px;
  height: 26px;
  background-color: #518dfa;
  border: none;
  color: #fff;
  font-size: 14px;
  outline: none;
  text-align: center;
  line-height: 26px;
  text-decoration: none;
  border-radius: 5px;
}

.news-cont-box {
  padding: 0 16px;
  box-sizing: border-box;
  overflow: hidden;
}

.title {
  font-size: 23px;
  color: #333;
  margin-bottom: 20px;
  font-weight: bold;
  margin-top: 70px;
}

.time {
  display: flex;
  font-size: 12px;
  align-items: center;
}

.time > li {
  margin-right: 10px;
  color: #999;
  font-size: 12px;
  height: 14px;
  line-height: 14px;
}


.Introduction-hidden {
  min-height: 300px;
  /* overflow: hidden; */
  position: relative;
}

.Introduction-hidden-icon {
  content: "";
  width: 100%;
  height: 200px;
  background-image: linear-gradient(transparent, #fff);
  z-index: 9999;
  margin-top: -200px;
  position: relative;
}

.Introduction-hidden-icon img {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  margin: auto;
}

.open-app {
  width: 100%;
  display: block;
  border: none;
  height: 44px;
  background-color: #518dfa;
  color: #fff;
  font-size: 14px;
  border-radius: 5px;
  margin-bottom: 22px;
  outline: none;
  text-align: center;
  line-height: 44px;
  text-decoration: none;
}

.open-app-border {
  width: 100%;
  display: block;
  border: none;
  height: 44px;
  border: 1px solid #518dfa;
  color: #518dfa;
  font-size: 14px;
  border-radius: 5px;
  margin-bottom: 22px;
  outline: none;
  text-align: center;
  line-height: 44px;
  text-decoration: none;
}

.all-com-title {
  font-size: 16px;
  color: #333;
  font-weight: bold;
  margin-bottom: 17px;
}

.host-list {
  width: 100%;
  margin-bottom: 25px;
}

.host-list > li {
  overflow: hidden;
  margin: 15px 0;
  font-size: 16px;
}

.host-list > li > img {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #fff;
  float: left;
  overflow: hidden;
}

.host-list > li > ul {
  width: calc(100% - 47px);
  float: right;
  overflow: hidden;
}

.host-list > li > ul > li:nth-child(1) {
  height: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.host-list > li > ul > li:nth-child(1) > p {
  font-size: 14px;
  color: #518dfa;
  max-width: 70%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.host-list > li > ul > li:nth-child(1) > span {
  font-size: 12px;
  color: #999;
}

.host-list > li > ul > li:nth-child(2) {
  font-size: 15px;
  color: #333;
  margin-top: 4px;
}

.news-links {
  overflow: hidden;
  margin-bottom: 60px;
}

.news-links > li {
  height: 86px;
  margin-bottom: 23px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.news-links > li > div {
  width: calc(100% - 130px);
  height: 86px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.news-links > li > div > p {
  font-size: 16px;
  color: #333;
  height: 66px;
  overflow: hidden;
}

.news-links > li > div > span {
  font-size: 12px;
  color: #8a8a8a;
  height: 20px;
  line-height: 20px;
}

.news-links > li > img {
  width: 114px;
  height: 86px;
  background-color: #999;
  border-radius: 3px;
}

.news-newList-item-left {
  height: 40px;
  width: calc(100% - 100px);
  display: flex;
  align-items: center;
}

.news-newList-item-left > img {
  border-radius: 3px;
  object-fit: cover;
}

.news-newList-item-left-text {
  width: calc(100% - 50px);
  height: 40px;
  margin-left: 10px;
}

.news-newList-item-left-text > p {
  color: #333333;
  font-size: 14px;
  height: 20px;
  line-height: 20px;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.news-newList-item-left-text > span {
  color: #8a8a8a;
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  display: block;
}
</style>
<style>
/* .down-app-btn {
  width: 81px;
  height: 25px !important;
  border-radius: 5px !important;
  font-size: 14px !important;
}

.down-app-btn-bottom {
  width: 58px;
  height: 24px !important;
  border-radius: 5px !important;
} */

.Introduction{
  margin-bottom: 16PX;
  margin-top: 22PX;
  overflow-y: auto;
  font-size: 18PX;
  line-height: 1.5;
  font-family: SourceHan;
  text-align: justify;
}
.Introduction img {
  width: 100%;
  display: block;
  margin: 5px auto;
  max-width: 100%;
  object-fit: scale-down;
}

.Introduction video {
  width: 100%;
  height: 200px;
  display: block;
  margin: 0 auto;
  max-width: 100%;
  background-color: #000;
}

.news-newList-box {
  width: 100%;
  height: 56px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 99999;
  border-top: 1px solid #eee;
  background-color: #fff;
}

.news-newList .van-swipe-item {
  width: 100%;
  height: 56px;
  line-height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 13px;
  box-sizing: border-box;
}

.news-newList .van-swipe__indicators {
  bottom: 7px;
}
</style>
